import React from "react";
import ErrorTile from "uikit/components/ErrorTile/ErrorTile";
import Card from "uikit/components/Card/Card";
import styles from "./CommonErrorBoundary.module.styl";

class CommonErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles.background}>
                    <Card className={styles.cardWrapper}>
                        <ErrorTile severity={"error"} />
                    </Card>
                </div>
            );
        }

        return this.props.children;
    }
}

export default CommonErrorBoundary;
